export default __webpack_public_path__ + "static/media/581.ea54edc1.gif";